import defaultState from './state';

const SET_CURRENT_TOAST = (state, toastObj) => {
  state.currentToast = toastObj;
};

const SET_GLOBAL_TOAST_VISIBILITY = (state, val) => {
  state.isGlobalToastVisible = val;
};

export default {
  SET_CURRENT_TOAST,
  SET_GLOBAL_TOAST_VISIBILITY
};



// WEBPACK FOOTER //
// ./src/store/modules/toasts/mutations.js